import request from '@/utils/request'


// 查询设备列表
export function listDevice(query) {
  return request({
    url: '/device/device/list',
    method: 'get',
    params: query
  })
}

// 查询设备分页
export function pageDevice(query) {
  return request({
    url: '/device/device/page',
    method: 'get',
    params: query
  })
}

// 查询设备详细
export function getDevice(data) {
  return request({
    url: '/device/device/detail',
    method: 'get',
    params: data
  })
}

// 新增设备
export function addDevice(data) {
  return request({
    url: '/device/device/add',
    method: 'post',
    data: data
  })
}

// 修改设备
export function updateDevice(data) {
  return request({
    url: '/device/device/edit',
    method: 'post',
    data: data
  })
}

// 删除设备
export function delDevice(data) {
  return request({
    url: '/device/device/delete',
    method: 'post',
    data: data
  })
}
